
import BackArrow from "../../components/backArrow"
import { images } from "../../constants"
import "./style.css"
import { useParams } from "react-router-dom";
import url from "../../config/axios"
import Loader from "../../components/Loader";
import { useEffect,useState } from "react";
const RefundPolicy=(back)=>{
  const {id}=useParams();
const[singledata,setSingledata]=useState()
const[loading,setLoading]=useState(false)
useEffect(()=>{
  setLoading(true);
url.get(`faq/id?id=${id}`).then(async(res)=>{
  if(res.data.success){
    setLoading(false);
    setSingledata(res.data.data.faq);
  }
}).catch((e)=>{
  setLoading(false);
})

},[])
    return(
        <div className=" d-flex justify-content-center align-items-center">
        <div className="screenHeight Form-Shadow  col-lg-9 col-md-10 col-sm-11 col-xs-12   pb-3">
        <div className="arrowback ps-3">
                <BackArrow back="/customer-support" black="black" />
              </div>
              <div>
{
  loading===true ? (<Loader heightsetting="screenHeight" />): (<>
    <h4 className="ms-4 mt-4">{singledata?.question}</h4>
       <div>
        <h5 className="ms-4 mt-4 mb-0">Answer:</h5>
        <p  className="m-0 ms-5 phera-3">{singledata?.answer}</p>
       
       </div>
       <div>
       <img className="ms-5 mt-4 pics-0" src={images.computer} />
       </div>

  </> )
}

              </div>
      
        </div>
      </div>
    )
}
export default RefundPolicy